import React from "react";
import SettingManagementMain from "../../components/SettingManagementMain";

const SettingManagementPage = () => {
  return (
    <React.Fragment>
      <SettingManagementMain />
    </React.Fragment>
  );
};

export default SettingManagementPage;
